import { useLocation, useNavigate } from 'react-router-dom';
import React, { useEffect, useState } from 'react';

const Shipping = ({ companyDetail }) => {


    const navigate = useNavigate();
    const location = useLocation();
    const [termCondition, setTermCondition] = useState("")

    useEffect(() => {
        if (location.state) {
            setTermCondition(location.state.term)
        }
    }, [location.state]);



    return (
        <>
            {/* Breadcrumb Section Start */}
            <section className="breadscrumb-section pt-0">
                <div className="container-fluid-lg">
                    <div className="row">
                        <div className="col-12">
                            <div className="breadscrumb-contain">
                                <h2>Shipping Policy </h2>
                                <nav>
                                    <ol className="breadcrumb mb-0">
                                        <li className="breadcrumb-item">
                                            <a href="/">
                                                <i className="fa-solid fa-house" />
                                            </a>
                                        </li>
                                        <li className="breadcrumb-item active" aria-current="page">
                                            Shipping Policy
                                        </li>
                                    </ol>
                                </nav>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            {/* Breadcrumb Section End */}
            {/* 404 Section Start */}
            <section className="section-404 section-lg-space">
                <div className="container-fluid-lg">
                    <div className="row">

                        <div className="col-12 bg-white p-3">
                        <div dangerouslySetInnerHTML={{ __html: companyDetail.company_policy }} className='editor inter-font'></div>

                            {/* <div>
                                <h4 className='inter-font fw-bold'>
                                    Q1. Where do you ship?</h4>
                                <h4>
                                    We currently offer nationwide delivery across India.
                                </h4>
                                <h4 className='inter-font fw-bold mt-5'>
                                    Q2. How long will my order take to arrive?
                                </h4>
                                <h4>
                                    We aim to process and dispatch all orders within 1–2 business days.
                                    Estimated delivery times:
                                </h4>
                                <h4>Metro cities: 2–4 business days</h4>
                                <h4>Other regions: 4–7 business days</h4>
                                <h4>Please note: During holidays or peak periods, there may be minor delays due to high order volumes or courier constraints.                                    </h4>


                                <h4 className='inter-font fw-bold mt-5'>Q3. How much is shipping?</h4>
                                <h4>We offer free shipping on all prepaid orders above ₹999. A nominal shipping fee may apply to smaller orders or COD requests.</h4>

                                <h4 className='inter-font fw-bold mt-5'>Q4. Do you offer COD (Cash on Delivery)?</h4>
                                <h4>Yes, COD is available for select pin codes. Please ensure accurate contact details at checkout.</h4>

                                <button
                                    onClick={() => navigate("/")}
                                    className="btn btn-md text-white theme-bg-color mt-4 mx-auto"
                                >
                                    Back To Home
                                </button>
                            </div> */}
                        </div>
                    </div>
                </div>
            </section>
            {/* 404 Section End */}
        </>
    )
}

export default Shipping;